'use strict';
var _ = require('lodash');

module.exports = function () {
  var args = arguments;

  if (_.size(args) === 0) {
    throw new Error('No arguments specified');
  }

  var evaluate;

  _.each(args, (a) => {
    if (!_.isFunction(a)) {
      throw new Error('Argument is not a function');
    }

    var b = evaluate;

    evaluate = function () {
      if (_.isNil(b)) {
        return a.apply(a, arguments);
      }
      return b.apply(evaluate, arguments) || a.apply(a, arguments);
    };
  });

  return evaluate;
};
